import {
  Product,
  ProductFilterModel,
  useCurrentWorkspace,
  useProductFilter,
} from '@gripp/shared-logic';
import { FilterType, ProductsSearchInput } from '@gripp/shared-ui';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { FilterBar } from '../../shared/components/filter/filterBar';
import { CreateProductButton } from './createProductButton';
import { ProductsList } from './productsList';

export const ProductsOld = () => {
  const navigate = useNavigate();
  const { data: productFilter } = useProductFilter();
  const currentWorkspace = useCurrentWorkspace();
  const impersonatingWorkspace = useCurrentWorkspace(true);

  const showCheckboxColumn = useMemo(
    () => !!impersonatingWorkspace,
    [impersonatingWorkspace]
  );

  const filter = useMemo(() => {
    const filter: ProductFilterModel =
      productFilter ?? new ProductFilterModel();
    filter.workspaceId = currentWorkspace?.id;
    return filter.getGraphQLFilter();
  }, [productFilter, currentWorkspace?.id]);

  const onProductClick = (product: Product) => {
    navigate(`/products/${product.id}`);
  };

  return (
    <View style={styles.container}>
      <View style={styles.filtersContainer}>
        <View style={styles.searchContainer}>
          <ProductsSearchInput />
        </View>
        <FilterBar filterButtonTypes={[FilterType.PRODUCTCOLUMNS]} />
        <CreateProductButton />
      </View>
      <ProductsList
        filter={filter}
        showCheckboxColumn={showCheckboxColumn}
        onProductClick={onProductClick}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 44,
    marginBottom: 20,
  },
  searchContainer: {
    width: 390,
    marginRight: 20,
  },
});
